import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/Home.css';
import { useUser } from './userContext';
import { tripAPI } from '../api/apiClient';
import AddTripPopup from './AddTripPopup';
import TripList from './TripList';
import useApi from './CustomHooks/useApi';
import LoadingOverlay from '../LoadingOverlay';
import { homeMenuItems } from '../config/homeMenuItems';
import * as FaIcons from 'react-icons/fa';

const Home = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const [trips, setTrips] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [loadError, setLoadError] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  const { callApi, isLoading } = useApi();

  useEffect(() => {
    if (!user) return;
    let active = true;
    setLoadError(false);
    setHasLoaded(false);
    callApi(
      () => tripAPI.getAllTripsWithBasicInfo(),
      (data) => { if (active) { setTrips(data); setHasLoaded(true); } },
      () => { if (active) { setLoadError(true); setHasLoaded(true); } }
    );
    return () => { active = false; };
  }, [user, reloadKey]);

  const handleActionClick = (item) => {
    if (item.path.startsWith('popup:')) {
      if (item.path === 'popup:add-trip') setShowPopup(true);
      return;
    }
    navigate(item.path);
  };

  const filteredMenuItems = useMemo(() => homeMenuItems.filter(item =>
    item.roles.some(role => user?.roles?.includes(role))
  ), [user]);

  return (
    <>


      <div className="home-container">
        <div className="home-shell">
          <header className="home-hero">
            <div className="home-heading">
              <div className="home-heading-icon"><FaIcons.FaMountain /></div>
              <div>
                <h1>Wycieczki</h1>
                <p>Przeglądaj i zarządzaj wycieczkami, do których masz dostęp.</p>
              </div>
            </div>

            <div className="home-actions">
              {filteredMenuItems.filter(item => item.path !== '/users' && item.path !== '/views').map((item) => {
                const Icon = FaIcons[item.icon];
                const isPrimary = item.path === 'popup:add-trip';
                return (
                  <button key={item.path} type="button" className={`home-action-button ${isPrimary ? 'home-action-button--primary' : ''}`} onClick={() => handleActionClick(item)}>
                    <Icon />
                    <span>{item.label}</span>
                  </button>
                );
              })}
            </div>
          </header>

          <AddTripPopup show={showPopup} onClose={() => setShowPopup(false)} />
          {!hasLoaded || isLoading ? (
            <LoadingOverlay text="Ładowanie danych..." />
          ) : loadError ? (
            <div className="no-trips-message" role="alert">
              <strong>Nie udało się pobrać wycieczek.</strong>
              <span>Sprawdź połączenie i spróbuj ponownie.</span>
              <button type="button" className="home-action-button" onClick={() => setReloadKey(key => key + 1)}>Spróbuj ponownie</button>
            </div>
          ) : <TripList trips={trips} />}
        </div>
      </div>
    </>
  );
};

export default Home;
